import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-abc5f866")

_pushScopeId("data-v-abc5f866")
const _hoisted_1 = {
  key: 0,
  class: "container-custom"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_ctx.window.parmonic_hide_localization != true && _ctx.languages.length > 0)
    ? (_openBlock(), _createBlock("div", _hoisted_1, [
        _createVNode("select", {
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleLanguageChange && _ctx.handleLanguageChange(...args))),
          class: "select-language"
        }, [
          _createVNode("option", {
            selected: _ctx.l == 'en',
            value: "en"
          }, "English", 8, ["selected"]),
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.languages, (l) => {
            return (_openBlock(), _createBlock("option", {
              key: l,
              selected: l === _ctx.language,
              value: l
            }, _toDisplayString(_ctx.getLanguageString(l) ?? l), 9, ["selected", "value"]))
          }), 128))
        ], 32)
      ]))
    : _createCommentVNode("", true)
})